import { AnalyticsBrowser } from '@segment/analytics-next'

// Initialize Segment Analytics with write key from environment variable
const segmentWriteKey = process.env.REACT_APP_SEGMENT_WRITE_KEY

if (!segmentWriteKey) {
  console.warn(
    'REACT_APP_SEGMENT_WRITE_KEY is not defined. Segment analytics will not be initialized.',
  )
}

// Create and export the Segment analytics instance
export const analytics = AnalyticsBrowser.load({
  writeKey: segmentWriteKey || '',
})

// Export the AnalyticsBrowser class for direct usage if needed
export { AnalyticsBrowser }

// Segment-specific tracking functions with human-readable event names
export function trackAuthStarted() {
  if (!analytics) {
    console.warn('Segment analytics not initialized')
    return
  }

  analytics.track('Auth Started')
}

export function trackAuthSubmitted(authMethod: 'email' | 'google' | 'apple') {
  if (!analytics) {
    console.warn('Segment analytics not initialized')
    return
  }

  analytics.track('Auth Submitted', {
    auth_method: authMethod,
  })
}

export function trackSignupStarted() {
  if (!analytics) {
    console.warn('Segment analytics not initialized')
    return
  }

  analytics.track('Signup Started')
}

export function trackSignupSubmitted(
  signupMethod: 'email' | 'google' | 'apple',
) {
  if (!analytics) {
    console.warn('Segment analytics not initialized')
    return
  }

  analytics.track('Signup Submitted', {
    signup_method: signupMethod,
  })
}

export function trackAddressSubmitted() {
  if (!analytics) {
    console.warn('Segment analytics not initialized')
    return
  }
  
  analytics.track('Address Submitted')
}

export function trackConnectionStarted(
  deviceType: 'vehicle' | 'charger' | 'thermostat' | 'utility',
  deviceBrand: string,
) {
  if (!analytics) {
    console.warn('Segment analytics not initialized')
    return
  }
  
  analytics.track('Connection Started', {
    device_type: deviceType,
    device_brand: deviceBrand,
  })
}
